<template>
  <div class="survey-complete-step">
    <div class="successful-text">
      <SmileOutlined class="happy-smile" />
      <p>Благодарим за прохождение опроса!</p>
    </div>
  </div>
</template>

<script>
import { SmileOutlined } from '@ant-design/icons-vue';

export default {
  name: 'SurveyCompleteStep',
  components: { SmileOutlined },
};
</script>

<style scoped lang="scss">
.survey-complete-step {
  padding: 0;
}

.successful-text {
  margin-bottom: 0;
  text-align: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);

  p {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 600;
  }

  .happy-smile {
    font-size: 65px;
    color: #52C41A;
    margin-bottom: 12px;
  }
}
</style>
